export default __webpack_public_path__ + "static/media/crypto-Liquidity.56409988.jpg";